import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { MatIcon } from "@angular/material/icon";
import { SkeletonComponent } from "@claas/claas-ui-components";
import { ToggleComponent } from "@claas/claas-ui-components/form/toggle";
import { applicationsStore } from "../../data/applications.store";
import { ApplicationCardComponent } from "../../ui/application-card/application-card";

@Component({
  selector: "app-application-list",
  templateUrl: "./application-list.html",
  styleUrls: ["./application-list.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ApplicationCardComponent,
    ToggleComponent,
    MatIcon,
    SkeletonComponent,
  ],
})
export class ApplicationListComponent {
  protected readonly store = inject(applicationsStore);

  protected toggleFavorite(id: string): void {
    this.store.toggleFavorite(id);
  }

  protected setOnlyFavorites(value: boolean): void {
    this.store.setOnlyFavorites(value);
  }
}
